import Image from "next/image";

import handCool from "../../assets/hand_cool.png";

export const LoadingHand = ({ className = "" }: { className?: string }) => {
  return (
    <div
      className={`absolute inset-0 w-full h-full bg-[#121212] flex items-center justify-center ${className}}`}
    >
      <div className="w-20 p-2 animate-pulse">
        <Image src={handCool} alt="loading" width={80} height={80} />
      </div>
    </div>
  );
};
